// The post-signup form remounts on every page load until it's submitted, and
// each mount would otherwise announce the lead to HQ again, so remember that
// we've already recorded the view for this user.
const STORAGE_KEY = "3b-post-signup-form-view-recorded";

// Storage-blocked browsers throw on any localStorage access; deduplication is
// best-effort, so a storage failure records again rather than dropping the lead.
export function hasRecordedPostSignupFormView(userId: string): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === userId;
  } catch {
    return false;
  }
}

export function markPostSignupFormViewRecorded(userId: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, userId);
  } catch {}
}

export function clearPostSignupFormViewRecord(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {}
}
